'use es6';

import { GLOBAL_NULL } from '../../constants/defaultNullValues';
import I18n from 'I18n';
export const generateGenericChannelLabel = (channelInfo, key) => channelInfo.get('label', key === GLOBAL_NULL ? null : I18n.text('reporting-data.references.generic-channel.unknown', {
  id: key
}));